module.exports = __webpack_public_path__ + "img/bottom_opening.c369cd38.png";